module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "degree-requirement req"
  }, [_c('div', {
    staticClass: "reqinfo"
  }, [_c('div', {
    staticClass: "requirement-name",
    on: {
      "click": function($event) {
        _vm.showSubreqs = !_vm.showSubreqs
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.req.name) + "\n      "), _c('i', {
    staticClass: "toggle-nested fa fa-caret-right",
    class: {
      'fa-rotate-90': _vm.showSubreqs
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "req-item"
  }, [(_vm.req.advanced) ? [_c('div', {
    staticClass: "req-satisfy variable blue"
  }, [_vm._v("Satisfy " + _vm._s(_vm.req.required) + " of " + _vm._s(_vm.subrequirements))]), _c('div', {
    staticClass: "req-satisfy credits blue"
  }, [_vm._v(_vm._s(_vm.req.minimum_credits) + " - " + _vm._s(_vm.req.maximum_credits) + " CR")])] : [_c('div', {
    staticClass: "req-satisfy variable"
  }, [_vm._v(_vm._s(_vm.req.minimum_credits) + " CR")]), _c('div', {
    staticClass: "req-satisfy credits"
  }, [_vm._v("Satisfy " + _vm._s(_vm.req.required) + " of " + _vm._s(_vm.subrequirements))])]], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubreqs),
      expression: "showSubreqs"
    }],
    staticClass: "subrequirements"
  }, _vm._l((_vm.req.subrequirements), function(req) {
    return _c('requirement', {
      key: req.id,
      ref: "requirements",
      refInFor: true,
      attrs: {
        "req": req
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dae13d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/degree_requirement.vue
// module id = 1138
// module chunks = 1